
import React from "react";
import { Classname } from "@rivtn/noseur";
import * as ReactRouterDom from "react-router-dom";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { ITeamWebsite } from "../../../../../services";

export interface SocialBandProps {
    website: ITeamWebsite;
}

function SocialBand({ website }: SocialBandProps) {

    const labels = i18nManager.Labels.home;
    const socials = Object.entries(website.social_accounts ?? {});
    const [, handle] = socials[0] ?? [];

    if (!socials.length) return null;

    return (<section className={styles["social-band"]}>
        <div className={Classname.build(styles["container"], styles["social-band-grid"])}>
            <h3 className={styles["social-band-title"]}>{labels.follow_us}</h3>
            <div>
                <h4 className={styles["social-band-handle"]}>@{handle}</h4>
                <div className={styles["social-icons"]}>
                    {socials.map(([social, username]) => (
                        <ReactRouterDom.NavLink key={social} target="_blank" to={Utils.getSocialLink(social, username)} aria-label={social} className={styles["social-btn"]}>
                            <i className={Utils.getSocialIcon(social) ?? "fa fa-link"} />
                        </ReactRouterDom.NavLink>
                    ))}
                </div>
            </div>
        </div>
    </section>);
}

export default SocialBand;
